import { render, staticRenderFns } from "./ExpensesTypesTable.vue?vue&type=template&id=23a9a7fc&"
import script from "./ExpensesTypesTable.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports